/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fall': {
    width: 16,
    height: 16,
    viewBox: '0 0 74.89 60',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M30.54 46.42c3.27 3.31 8.94 4.54 12.56 2.73l11.07-5.45 7.89 13.8c2.56 4.46 9.25.63 6.7-3.83l-9.21-16.1a3.86 3.86 0 0 0-4.84-1.64l-7.08 3 7.12-6.35 14.66 4.12c5 1.5 7.15-6.08 2.1-7.42l-16.7-4.72a3.86 3.86 0 0 0-3.62.83L42 33.58l-4.39-8.78-1.23-2.47c3.47-1.51 5.74-2.59 7.55-4.46 2.73-2.82 3.31-6.3 5.61-13.85A2.7 2.7 0 0 0 46.92.5a2.7 2.7 0 0 0-2.54 1.95C42 10.12 41.32 12.81 40 14.13c-.82.84-3 1.9-6.11 3.31l-11.76 5.89a4.8 4.8 0 0 1-3.71.08 26.53 26.53 0 0 1-5.61-2.74c-2-1.56-3.4-4.14-7.17-11.72A2.7 2.7 0 1 0 .8 11.36C4.57 18.93 6.21 22.42 9.53 25c2.88 2.2 6.38 3.3 12.68 5.84l.67 1.35 2.65 5.31M23.31 6.76a6.88 6.88 0 1 0 6.91 6.88 6.89 6.89 0 0 0-6.91-6.88z" id="Layer_1-2" data-name="Layer 1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/fall.js